import React from 'react';
import { Drawer, Icon } from '@blend-ed/blendx-ui';
import { Link } from 'react-router-dom';
import EventCard from '../../components/EventCard';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from '../../components/messages';

const EventDrawer = ({ showDrawer, handleCloseDrawer, todaysEvents, upcomingEvents }) => {
    const intl = useIntl();

    return (
        <Drawer show={showDrawer} onClose={handleCloseDrawer} className="events-drawer" size="lg">
            <Drawer.Header title={intl.formatMessage(messages.events)} className="events-drawer-header" />
            <Drawer.Body className="events-drawer-body">
                <div className="events-list">
                    <div className="events-list-title">{intl.formatMessage(messages.today)}</div>
                    <div className="events-list-content">
                        {todaysEvents.length > 0 ? todaysEvents.map((event, index) => (
                            <EventCard key={index} title={event.title} date={event.start} variant={event.variant} link={event.link} description={event.description} />
                        ))
                            : <div className="no-events">{intl.formatMessage(messages.noEventsToday)}</div>}
                    </div>
                </div>
                <div className="events-list">
                    <div className="events-list-title">{intl.formatMessage(messages.upcoming)}</div>
                    <div className="events-list-content">
                        {upcomingEvents.length > 0 ? upcomingEvents.map((event, index) => (
                            <EventCard key={index} title={event.title} date={event.start} variant={event.variant} link={event.link} description={event.description} />
                        ))
                            : <div className="no-events">{intl.formatMessage(messages.noEventsUpcoming)}</div>}
                    </div>
                </div>
            </Drawer.Body>
        </Drawer>
    )
}

export default EventDrawer;